import { render, staticRenderFns } from "./BuscaAnoTurmaDisciplinaAEEouACP.vue?vue&type=template&id=6e65b668&"
import script from "./BuscaAnoTurmaDisciplinaAEEouACP.vue?vue&type=script&lang=js&"
export * from "./BuscaAnoTurmaDisciplinaAEEouACP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports